module.exports = __webpack_public_path__ + "7e74daa3079f23b59f4afacc53c3a6f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/valorant/haven.png
// module id = 445
// module chunks = 0